/* Royal Bar Carts - rbc-review-filter.js  (v3, 6 October 2026)
   SITE-AUDIT A18, owner instruction. Removes two Judge.me reviews wherever the
   storefront shows them. Judge.me widget 3.0 (Vue) renders the product review
   list, its photo gallery strip and the lightbox from JSON embedded in the page
   (jdgm.data.reviewWidget) and from fetch() calls to api.judge.me; older widgets
   (snippet cards, carousel, all-reviews page) use `[data-review-id]` markup.
   Layers, keyed on review uuids and the reviews' photo filenames only:
     1. every object carrying one of the uuids is removed from the embedded data,
        wherever it sits (reviews, photo_gallery, ...), and from every JSON
        response the widget fetches from judge.me;
     2. the photo filenames of the removed objects are collected, so their
        thumbnails are removed even where the markup carries no uuid;
     3. any jm-/jdgm- element carrying one of the uuids in any attribute, or
        showing one of the photos, is removed on load and on every DOM change.
   Pairs with the CSS rule in rbc-global.css. No dependencies. */
(function () {
  var IDS = ['692b0e21-949c-46cb-9ac2-171ec8cec7d1', '81c131d0-898c-4e6a-8b59-950e7575df9d'];
  var FILES = ['1791260861__1000017928', '1791260945__inbound6685722503530847466',
               '1791260949__inbound3702942137255793556', '1791260953__inbound1958471974585259286',
               '1791260955__inbound3197797907271133256'];
  var ATTRS = ['review-uuid', 'data-review-id', 'data-review-uuid', 'data-uuid', 'data-id', 'id'];
  var WRAP = '.jm-review-item, .jdgm-rev, .jdgm-full-rev, .jdgm-gallery__thumbnail-link, .jdgm-rev__pic-link, .jdgm-carousel-item, .jdgm-rev-snippet-card, .jdgm-popup-card, [class*="gallery-item"], [class*="gallery__item"], [class*="media-item"], [class*="thumbnail"]';
  var SCOPE = '[class*="jm-"], [class*="jdgm-"]';
  var FILE_RE = /review-images\.judgeme\.com\/[^/"'\s]+\/([0-9]+__[A-Za-z0-9]+)__/g;

  function isTarget(v) { return typeof v === 'string' && IDS.indexOf(v) !== -1; }
  function learnFiles(obj) {
    var s; try { s = JSON.stringify(obj); } catch (e) { return; }
    var m; while ((m = FILE_RE.exec(s)) !== null) { if (FILES.indexOf(m[1]) === -1) FILES.push(m[1]); }
  }
  /* 1. deep filter: drop any object whose uuid is a target, anywhere in the tree */
  function deepFilter(node, depth) {
    if (!node || typeof node !== 'object' || depth > 12) return node;
    if (Array.isArray(node)) {
      for (var i = node.length - 1; i >= 0; i--) {
        var it = node[i];
        if (it && typeof it === 'object' && isTarget(it.uuid)) { learnFiles(it); node.splice(i, 1); }
        else deepFilter(it, depth + 1);
      }
      return node;
    }
    Object.keys(node).forEach(function (k) {
      var v = node[k];
      if (v && typeof v === 'object') {
        if (!Array.isArray(v) && isTarget(v.uuid)) { learnFiles(v); delete node[k]; }
        else deepFilter(v, depth + 1);
      }
    });
    return node;
  }
  function filterData() {
    [window.jdgm && window.jdgm.data, window.judgeme && window.judgeme.data].forEach(function (d) { if (d) deepFilter(d, 0); });
  }
  /* 1b. the same filter on every JSON the widget fetches from judge.me */
  if (window.fetch && !window.fetch.__rbcWrapped) {
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (!/judge\.me/.test(url)) return p;
      return p.then(function (res) {
        var ct = res.headers && res.headers.get && (res.headers.get('content-type') || '');
        if (!/json/.test(ct)) return res;
        return res.clone().json().then(function (json) {
          deepFilter(json, 0);
          return new Response(JSON.stringify(json), { status: res.status, statusText: res.statusText, headers: res.headers });
        }).catch(function () { return res; });
      });
    };
    wrapped.__rbcWrapped = true; window.fetch = wrapped;
  }
  /* 2 + 3. remove rendered elements */
  function mediaSelector() {
    return FILES.map(function (f) {
      return 'img[src*="' + f + '"],img[data-src*="' + f + '"],img[srcset*="' + f + '"],source[srcset*="' + f + '"],a[href*="' + f + '"],a[data-mfp-src*="' + f + '"],[style*="' + f + '"],[data-background*="' + f + '"]';
    }).join(',');
  }
  var ATTR_SEL = ATTRS.map(function (a) { return IDS.map(function (id) { return '[' + a + '="' + id + '"]'; }).join(','); }).join(',');
  function sweep() {
    document.querySelectorAll(ATTR_SEL).forEach(function (el) { el.remove(); });
    document.querySelectorAll(SCOPE).forEach(function (el) {
      for (var i = 0; i < el.attributes.length; i++) { if (isTarget(el.attributes[i].value)) { el.remove(); return; } }
    });
    document.querySelectorAll(mediaSelector()).forEach(function (el) {
      var wrap = el.closest ? el.closest(WRAP) : null;
      (wrap || (el.closest && el.closest('a')) || el).remove();
    });
  }
  function start() {
    filterData(); sweep();
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () { filterData(); sweep(); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ATTRS.concat(['src', 'srcset', 'href', 'style']) });
    }
  }
  filterData();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
